import React from 'react'
import TextInput from '../form/TextInput'
import FileInput from '../form/FileInput'
import { SketchPicker } from 'react-color';
import AppBlobCache from '../../AppBlobCache'
import {Collapse,ButtonGroup,Button} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight,faCaretDown} from '@fortawesome/free-solid-svg-icons'


export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      open:""
    }
    this.onChangeItem = this.onChangeItem.bind(this);
  }

  onChangeItem()
  {
    this.props.onChangeItem && this.props.onChangeItem();
    //console.log("StoryItemSetting:onChangeItem");
  }

  render()
  {
    var {
      item
    } = this.props;

    var t = this;
    
    return (
        (item.isSelected)?
        <div class="accordion">
          {
            this.props.item.type === 'Text' || this.props.item.type === 'Media' ? (              
                  <div class="card">
                  <h5 class="card-header">                      
                      <button class="btn btn-link" type="button" onClick={()=>
                      {
                        if (this.state.open=='characterBox')
                          this.setState({open:""});
                        else
                        this.setState({open:"characterBox"});
                      }}>
                        角色 {this.state.open=="characterBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}                                          
                      </button>
                      <input type={`checkbox`}
                             checked={!!this.props.item.name.enabled}
                             onChange={(e) => {
                               this.props.item.name.enabled = e.target.checked;
                               t.props.onChangeItem();
                             }}/>
                      
                  </h5>                    
                    {this.props.item.name.enabled===true ? (        
                    <Collapse isOpen={this.state.open=="characterBox"}>
                      <div class="card-body">
                        <p>
                          <label>角色名稱</label>
                          <input type={`text`}
                                value={this.props.item.name._text}
                                onChange={(e) => {
                                  this.props.item.name._text = e.target.value;
                                  this.forceUpdate();
                                  t.props.onChangeItem();
                                }}/>                        
                        </p>

                        <p>
                          <label>文字顏色</label><br/><br/>
                          <SketchPicker
                          disableAlpha={true}   
                            presetColors={['#FFFFFF','#FF0000','#00FF00','#0000FF']}             
                                color={item.name._attributes.color}
                                onChangeComplete={function(color,e){
                                  item.name._attributes.color = color.hex;
                                  t.forceUpdate();
                                  t.props.onChangeItem();
                                }}            
                            />      
                        </p>

                        <p>                          
                          <ButtonGroup>
                            <div class="input-group-prepend">
                              <div class="input-group-text">文字大小</div>
                            </div>        
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.size = 'small';t.props.onChangeItem();}} active={this.props.item.name._attributes.size === 'small'}>小</Button>
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.size = 'medium';t.props.onChangeItem();}} active={this.props.item.name._attributes.size === 'medium'}>中</Button>
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.size = 'large';t.props.onChangeItem();}} active={this.props.item.name._attributes.size === 'large'}>大</Button>
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.size = 'xlarge';t.props.onChangeItem();}} active={this.props.item.name._attributes.size ==='xlarge'}>特大</Button>
                          </ButtonGroup>
                        </p>

                        <p>                          
                          <ButtonGroup>
                            <div class="input-group-prepend">
                              <div class="input-group-text">字體粗細</div>
                            </div>        
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.style = 'light';t.props.onChangeItem();}} active={this.props.item.name._attributes.style === 'light'}>幼體</Button>                            
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.style = 'regular';t.props.onChangeItem();}} active={this.props.item.name._attributes.style === 'regular'}>正常</Button>
                            <Button color="primary" onClick={() => {this.props.item.name._attributes.style = 'bold';t.props.onChangeItem();}} active={this.props.item.name._attributes.style === 'bold'}>粗體</Button>                            
                          </ButtonGroup>
                        </p>
                      </div>
                    </Collapse>
                    ):null}
                  </div>                
            ) : null

          }

          {
            this.props.item.type === 'Text' || this.props.item.type === 'Media' ? (
              
              <div class="card">
                <h5 class="card-header">
                  <button class="btn btn-link" type="button" onClick={()=>
                    {
                      if (this.state.open=='dialogueBox')
                        this.setState({open:""});
                      else
                      this.setState({open:"dialogueBox"});
                    }}>
                    對話框 {this.state.open=="dialogueBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}                                          
                  </button>
                </h5>     
                <Collapse isOpen={this.state.open=="dialogueBox"}>
                  <div class="card-body">
                    <p>
                      <label>對話框顏色</label><br/><br/>
                      <SketchPicker                   
                          disableAlpha={true}
                          presetColors={['#666666','#FFFFFF','#f8f2c6', '#ddf8c6', '#ffc1c5', '#c6f0f8']}             
                          color={this.props.item._attributes.itemColor}
                          onChangeComplete={function(color,e){
                            item._attributes.itemColor = color.hex;                            
                            t.props.onChangeItem();
                          }}            
                      />
                    </p>                      
                    </div>
                </Collapse>
              </div>
              
            ):null
          }
          
          
          {
            this.props.item.type === 'Text' || this.props.item.type === 'Narrative' ? (                
                  <div class="card">
                    <h5 class="card-header">
                      <button class="btn btn-link" type="button" onClick={()=>
                        {
                          if (this.state.open=='contentBox')
                            this.setState({open:""});
                          else
                          this.setState({open:"contentBox"});
                        }
                        }>
                        內文 {this.state.open=="contentBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}                                          
                      </button>
                    </h5>                                        
                    <Collapse isOpen={this.state.open=="contentBox"}>
                      <div class="card-body">                      
                        <p>
                          <label>內文顏色</label><br/><br/>
                          <SketchPicker   
                              disableAlpha={true}             
                              color={this.props.item.text._attributes.color}
                              presetColors={["#000000","#FFFFFF",'#666666', '#FF0000']}
                              onChangeComplete={function(color,e){
                                item.text._attributes.color = color.hex;                                
                                t.props.onChangeItem();
                              }}            
                          />
                        </p>

                        <p>                         
                          <ButtonGroup>
                            <div class="input-group-prepend">
                              <div class="input-group-text">文字大小</div>
                            </div>        
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.size = 'small';t.props.onChangeItem();}} active={this.props.item.text._attributes.size === 'small'}>小</Button>
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.size = 'medium';t.props.onChangeItem();}} active={this.props.item.text._attributes.size === 'medium'}>中</Button>
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.size = 'large';t.props.onChangeItem();}} active={this.props.item.text._attributes.size === 'large'}>大</Button>
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.size = 'xlarge';t.props.onChangeItem();}} active={this.props.item.text._attributes.size ==='xlarge'}>特大</Button>
                          </ButtonGroup>                          
                        </p>

                        <p>                          
                          <ButtonGroup>
                            <div class="input-group-prepend">
                              <div class="input-group-text">字體粗細</div>
                            </div>        
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.style = 'light';t.props.onChangeItem();}} active={this.props.item.text._attributes.style === 'light'}>幼體</Button>                            
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.style = 'regular';t.props.onChangeItem();}} active={this.props.item.text._attributes.style === 'regular'}>正常</Button>
                            <Button color="primary" onClick={() => {this.props.item.text._attributes.style = 'bold';t.props.onChangeItem();}} active={this.props.item.text._attributes.style === 'bold'}>粗體</Button>                            
                          </ButtonGroup>
                        </p>
                      </div>
                    </Collapse>
                  </div>                
            ) : null

          }

{
            this.props.item.type === 'Text' && global.DEBUG ? (                
                  <div class="card">
                    <h5 class="card-header">
                      <button class="btn btn-link" type="button" onClick={()=>
                        {
                          if (this.state.open=='urlBox')
                            this.setState({open:""});
                          else
                          this.setState({open:"urlBox"});
                        }
                        }>
                        URL {this.state.open=="urlBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}                                          
                      </button>
                    </h5>                                        
                    <Collapse isOpen={this.state.open=="urlBox"}>
                      <div class="card-body">                      
                      <p>
                          <label>URL </label>
                          <input type={`text`}
                                value={this.props.item.url._text}
                                onChange={(e) => {
                                  this.props.item.url._text = e.target.value;
                                  this.forceUpdate();
                                  t.props.onChangeItem();
                                }}/>                        
                        </p>                        
                      </div>
                    </Collapse>
                  </div>                
            ) : null

          }

          {this.props.item.type === 'Media' ? (              
                <div class="card">
                    <h5 class="card-header">
                      挑選JPG 圖檔
                    </h5>
                    <div class="card-body">
                      <FileInput value={this.props.item.media._attributes.src}
                                  file_type={'image'}
                                  file_ext={'jpg'}
                                  onChange={(e, value, blob_url,base64_raw,file_ext) => {
                                    this.props.item.media._attributes.src = value;
                                    this.props.item.media._attributes.secondarySrc = value;
                                    this.props.item.media._attributes.base64_data = base64_raw;                                    
                                    this.props.item.media._attributes.file_ext = file_ext;                                                                                                          
                                    t.props.onChangeItem();
                                  }}/>                               
                    </div>                                  
                </div>              
            ) : null
          }

          


          {
            this.props.item.type === 'Text' || this.props.item.type === 'Narrative'  ? (
                <div>
                  <div class="card">
                  <h5 class="card-header">
                      <button class="btn btn-link" type="button" onClick={()=>
                        {
                          if (this.state.open=='backgroundBox')
                            this.setState({open:""});
                          else{
                            this.setState({open:"backgroundBox"});
                            this.props.item.bg.enabled = 1;
                          }

                        }
                        }>
                        背景 {this.state.open=="backgroundBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}                                          
                      </button>
                    <input type={`checkbox`}                                        
                             checked={!!this.props.item.bg.enabled}
                             onChange={(e) => {
                               this.props.item.bg.enabled = e.target.checked;
                               this.forceUpdate();
                             }}                             
                             title={(this.props.item.bg.enabled)?"消除背景效果":""}
                             />
                  </h5>
                    
                    <Collapse isOpen={this.state.open=="backgroundBox"}>
                      <div class="card-body">

                          <p>
                          <label>插入背景</label>
                          <select value={this.props.item.bg._attributes.type}
                                  onChange={(e) => {
                                    this.props.item.bg._attributes.type = e.target.value;
                                    delete item.bg._attributes.color;
                                    this.forceUpdate();
                                  }}>
                            <option value={''}>{'請選擇格式'}</option>
                            <option value={'color'}>{'顏色'}</option>
                            <option value={'image'}>{'jpg 圖檔'}</option>
                            <option value={'video'}>{'mp4 影片'}</option>
                          </select>
                        </p>
                        {
                          this.props.item.bg._attributes.type === 'color' ? (
                        <p>
                          <label>顏色</label> <br/><br/>                       
                          <SketchPicker 
                          disableAlpha={true}  
                            presetColors={['#000000','#FFFFFF','#FF0000','#00FF00','#0000FF']}             
                                color={item.bg._attributes.color}
                                onChangeComplete={function(color,e){
                                  item.bg._attributes.color = color.hex;
                                  t.forceUpdate();
                                }}            
                            />
                        </p>
                          ) : null
                        }                    
                        {
                          this.props.item.bg._attributes.type === 'image' ? (
                              <p>
                                <label>上傳圖檔</label>
                                <FileInput value={this.props.item.bg._attributes.src}
                                          file_type={'image'}
                                          file_ext={'jpg'}
                                          onChange={(e, value, blob_url, base64_raw,file_ext) => {
                                            this.props.item.bg._attributes.src = value;
                                            this.props.item.bg._attributes.base64_data = base64_raw;
                                            this.props.item.bg._attributes.file_ext = file_ext;
                                            alert("背景效果可於預覽中檢視");  
                                            this.forceUpdate();
                                          }}/>
                              </p>
                          ) : null
                        }
                        {
                          this.props.item.bg._attributes.type === 'video' ? (
                              <p>
                                <label>上傳影片</label>
                                <FileInput value={this.props.item.bg._attributes.src}
                                          file_type={'video'}
                                          file_ext={'mp4'}
                                          onChange={(e, value, blob_url,base64_raw,file_ext) => {
                                            this.props.item.bg._attributes.src = value;
                                            this.props.item.bg._attributes.base64_data = base64_raw;
                                            this.props.item.bg._attributes.file_ext = file_ext;
                                            alert("背景效果可於預覽中檢視");  
                                            this.forceUpdate();
                                          }}/>
                              </p>
                          ) : null
                        }
                      </div>
                    </Collapse>
                    
                  </div>
                </div>
            ) : null

          }          
        </div>:null
    )
  }
}